(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("InvoiceNewController", InvoiceNewController);

    function InvoiceNewController(
        $q,
        $http,
        $scope,
        $window,
        $timeout,
        systemConstants,
        CustomerService,
        UserService,
        StoreInfoFactory,
        $localStorage,
        toastr,
        $translate,
        $state,
        $stateParams,
        $uibModal,
        InvoicesService,
        CheckCEPService,
        StoreService,
        DiscountCouponService,
        InvoiceUtilsService,
        FlyersService
    ) {
        var vm = this;

        vm.hubId = null;

        function refreshImmoContext() {
            var fromHub =
                vm.hubId != null &&
                vm.hubId === systemConstants.IMMO_HUB_ID;
            var fromStorage = !!(
                $localStorage.defaultStore &&
                $localStorage.defaultStore.immoContext
            );
            vm.isImmoContext = fromHub || fromStorage;
        }

        refreshImmoContext();

        vm.store = $localStorage.defaultStore;
        vm.currencyPrefix = getCurrencyListConfiguration()["REAL"].prefix;
        vm.isBrl = true;

        vm.randomTime = new Date().getTime();

        vm.height = window.innerHeight;
        vm.states = getAllStates();

        function setDynamicDivHeight() {
            vm.height = window.innerHeight;
        }

        window.addEventListener("load", setDynamicDivHeight);
        window.addEventListener("resize", setDynamicDivHeight);

        // Auxiliaries for sellers entities
        vm.querySearchSellers = querySearchSellers;
        vm.selectedSellerChange = selectedSellerChange;
        vm.querySearchCustomers = querySearchCustomers;
        vm.selectedCustomerChange = selectedCustomerChange;
        vm.searchTextCustomer = '';
        vm.selectedCustomerModel = null;
        vm.isMobile =
            $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;
        vm.sellerModalVisible = false;
        vm.sellerMobileSearch = "";
        vm.sellerMobileResults = [];
        vm.initialSeller = null;
        vm.pendingSeller = null;
        vm.sellerListItemClicked = false;
        vm.productModalVisible = false;
        vm.productMobileSearch = "";
        vm.productMobileResults = [];
        vm.pendingProduct = null;
        vm.productListItemClicked = false;
        vm.searchTextProduct = "";
        vm.selectedProductItem = null;
        vm.querySearchProducts = querySearchProducts;
        vm.onProductSelectedFromSearch = onProductSelectedFromSearch;
        vm.clearProductSearchField = clearProductSearchField;
        vm.toggleProductModal = toggleProductModal;
        vm.filterProductMobile = filterProductMobile;
        vm.onProductMobileRowClick = onProductMobileRowClick;
        vm.isProductRowSelected = isProductRowSelected;
        vm.closeProductModal = closeProductModal;
        vm.confirmProductSelection = confirmProductSelection;

        vm.showLineItemColorSelector = showLineItemColorSelector;
        vm.isLineItemVariationSelectDisabled = isLineItemVariationSelectDisabled;

        var onInvoiceResize = function() {
            $scope.$applyAsync(function() {
                vm.isMobile =
                    $window.innerWidth <=
                    systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;
                if (!vm.isMobile) {
                    vm.sellerModalVisible = false;
                    vm.productModalVisible = false;
                }
            });
        };
        angular.element($window).on("resize", onInvoiceResize);
        $scope.$on("$destroy", function() {
            angular.element($window).off("resize", onInvoiceResize);
        });

        function sameSellerByIdOrRef(referenceSeller, candidateRowSeller) {
            if (!referenceSeller || !candidateRowSeller) {
                return false;
            }
            if (referenceSeller.id != null && candidateRowSeller.id != null) {
                return referenceSeller.id === candidateRowSeller.id;
            }
            return referenceSeller === candidateRowSeller;
        }

        vm.isSellerRowSelected = function(candidateRowSeller) {
            var referenceSeller =
                vm.sellerListItemClicked && vm.pendingSeller
                    ? vm.pendingSeller
                    : vm.initialSeller;
            return sameSellerByIdOrRef(referenceSeller, candidateRowSeller);
        };

        vm.filterSellerMobile = function() {
            if (!vm.sellers) {
                vm.sellerMobileResults = [];
                return;
            }
            querySearchSellers(vm.sellerMobileSearch).then(function(results) {
                vm.sellerMobileResults = results || [];
            });
        };

        vm.toggleSellerModal = function() {
            if (!vm.sellerModalVisible) {
                vm.initialSeller = vm.selectedSeller
                    ? angular.copy(vm.selectedSeller)
                    : null;
                vm.sellerListItemClicked = false;
                vm.pendingSeller = null;
                vm.sellerMobileSearch = "";
            }
            vm.sellerModalVisible = !vm.sellerModalVisible;
            if (vm.sellerModalVisible) {
                vm.filterSellerMobile();
            }
        };

        vm.onSellerMobileRowClick = function(seller) {
            vm.sellerListItemClicked = true;
            vm.pendingSeller = seller;
        };

        vm.closeSellerModal = function() {
            if (!vm.sellerModalVisible) {
                return;
            }
            if (vm.initialSeller) {
                selectedSellerChange(angular.copy(vm.initialSeller));
                vm.searchTextSeller = vm.getTreatedName(vm.selectedSeller);
            } else {
                selectedSellerChange(null);
                vm.searchTextSeller = "";
            }
            vm.sellerModalVisible = false;
            vm.sellerMobileSearch = "";
            vm.sellerMobileResults = [];
            vm.pendingSeller = null;
            vm.sellerListItemClicked = false;
        };

        vm.confirmSellerSelection = function() {
            if (vm.sellerListItemClicked && vm.pendingSeller) {
                selectedSellerChange(vm.pendingSeller);
            } else {
                selectedSellerChange(vm.initialSeller);
            }
            if (vm.selectedSeller) {
                vm.searchTextSeller = vm.getTreatedName(vm.selectedSeller);
            } else {
                vm.searchTextSeller = "";
            }
            vm.sellerModalVisible = false;
            vm.sellerMobileSearch = "";
            vm.sellerMobileResults = [];
            vm.pendingSeller = null;
            vm.sellerListItemClicked = false;
        };

        vm.invoice = {
            storeId: StoreInfoFactory.getStoreId(),
            externalChannel: 'SHOWKASE',
            shippingOption: "PICK_UP_IN_STORE",
            paymentMethod: "DIRECT_SALE",
            paymentCondition: "MONEY",
            availablePaymentConditions: [],
            shippingValue: 0,
            customer: {},
            items: [],
            currency: "REAL",
        };

        vm.externalChannelOptions = InvoiceUtilsService.getExternalChannelOptions(false);

        vm.fixedValue = null;
        vm.standaloneProductName = null;
        vm.paymentLinkMessage = "";
        vm.isSaving = false;
        vm.isGeneratingLink = false;
        vm.paymentLinkEnabled = InvoiceUtilsService.isPaymentLinkEnabled();

        vm.salesPoints = [];
        vm.selectedSalesPointId = null;
        vm.formatSalesPointAddress = InvoiceUtilsService.formatSalesPointAddress;

        var cloneFromUuid = $stateParams.cloneFromUuid;
        var pendingCloneData = null;

        vm.selectedCoupon = undefined;
        vm.cloneCouponInitialValue = undefined;
        vm.purchaseValue = 0;

        init();

        function init() {
            loadStore();
            getUsersSellers();
            loadSalesPoints();
            if (cloneFromUuid) {
                loadCloneData(cloneFromUuid);
            }
            $translate.onReady(function () {
                regeneratePaymentLinkMessageIfPristine();
            });
        }

        function buildPaymentLinkMessage() {
            return InvoiceUtilsService.buildPaymentLinkMessage(
                vm.invoice.customer,
                "invoice.new"
            );
        }

        function regeneratePaymentLinkMessageIfPristine() {
            if (cloneFromUuid) {
                return;
            }
            var ctrl = $scope.invoiceNewForm && $scope.invoiceNewForm.paymentLinkMessage;
            if (!ctrl || ctrl.$pristine) {
                vm.paymentLinkMessage = buildPaymentLinkMessage();
            }
        }

        function loadCurrencyPrefix(store) {
            vm.invoice.currency = store.currency ? store.currency : "REAL";
            var config = getCurrencyListConfiguration()[vm.invoice.currency];
            vm.currencyPrefix = config.prefix;
        }

        vm.sellerRowAvatarStyle = function (user) {
            if (
                user &&
                user.userProfiles &&
                user.userProfiles.length &&
                user.userProfiles[0].colorCode
            ) {
                return {
                    "background-color": user.userProfiles[0].colorCode,
                };
            }
            return {};
        };

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId).then(
                function (response) {
                    if (response && response.data) {
                        vm.store = response.data;
                        vm.storeCategory = response.data.categoryKey;
                        vm.isBrl = response.data.langKey == "pt-br";
                        vm.hubId = response.data.hubId;
                        refreshImmoContext();
                        loadCurrencyPrefix(vm.store);
                    }
                }
            );
        }

        function getUsersSellers() {
            UserService.getUsersSellers({storeId: vm.invoice.storeId}).then(
                function (response) {
                    vm.sellers = response.data;
                    vm.searchTextSeller = "";
                    var cloneSellerId = pendingCloneData && pendingCloneData.sellerInfo && pendingCloneData.sellerInfo.id;
                    if (cloneSellerId) {
                        var cloneSeller = _.find(vm.sellers, function (user) {
                            return user.id === cloneSellerId;
                        });
                        if (cloneSeller) {
                            selectedSellerChange(cloneSeller);
                            return;
                        }
                    }
                    var defaultSeller = _.find(vm.sellers, function (user) {
                        return user.id === $localStorage.userId;
                    });
                    selectedSellerChange(defaultSeller || null);
                }
            );
        }

        function querySearchSellers(query) {
            var results = query
                ? vm.sellers.filter(InvoiceUtilsService.buildSellerFilter(query))
                : vm.sellers;
            var defer = $q.defer();
            defer.resolve(results);
            return defer.promise;
        }

        function selectedSellerChange(seller) {
            if (seller) {
                vm.invoice.sellerId = seller.id;
                vm.invoice.sellerName = seller.fullName;
                vm.selectedSeller = seller;
            } else {
                vm.invoice.sellerId = null;
                vm.invoice.sellerName = null;
                vm.selectedSeller = null;
            }
        }

        function loadSalesPoints() {
            if (!vm.paymentLinkEnabled) {
                return;
            }
            StoreService.getSalesPoints($localStorage.defaultStore.storeId).then(function (response) {
                vm.salesPoints = (response && response.data) ? response.data : [];
                vm.selectedSalesPointId = InvoiceUtilsService.autoSelectSalesPoint(vm.salesPoints, vm.selectedSalesPointId);
            });
        }

        function loadCloneData(uuid) {
            InvoicesService.getPaymentLinkDetails(uuid).then(function (res) {
                var data = res.data || {};
                pendingCloneData = data;

                var payment = data.paymentInfo || {};
                var shipping = data.shippingInfo || {};
                var cart = data.cartInfo || {};

                vm.invoice.availablePaymentConditions = angular.copy(payment.availablePaymentMethods || []);
                vm.invoice.shippingOption = (shipping.receiveInStore === false) ? "RECEIVE_AT_HOME" : "PICK_UP_IN_STORE";
                vm.invoice.shippingValue = cart.shippingValue || 0;
                if (shipping.salesPointId) {
                    vm.selectedSalesPointId = String(shipping.salesPointId);
                }
                vm.invoice.customer = mapCloneCustomer(data);
                if (vm.invoice.customer && vm.invoice.customer.fullName) {
                    vm.selectedCustomerModel = vm.invoice.customer;
                    vm.searchTextCustomer = vm.invoice.customer.fullName;
                }
                vm.paymentLinkMessage = data.paymentLinkMessage || "";
                vm.invoice.notes = data.deliveryObservation || "";

                var sellerId = data.sellerInfo && data.sellerInfo.id;
                if (vm.sellers && sellerId) {
                    var seller = _.find(vm.sellers, function (user) {
                        return user.id === sellerId;
                    });
                    if (seller) {
                        selectedSellerChange(seller);
                    }
                }

                var list = cart.flyerList || [];
                var isFixedValue = list.length === 1 && !list[0].flyerId;
                if (isFixedValue) {
                    vm.fixedValue = cart.subTotalPurchasePrice > 0 ? cart.subTotalPurchasePrice : null;
                    vm.standaloneProductName = list[0].name || null;
                    vm.calculatePrice();
                } else if (list.length) {
                    rebuildCloneItems(list);
                }

                applyCloneCoupon(cart);
            }, function () {
                toastr.error($translate.instant("invoice.new.messages.error-to-load-clone"));
            });
        }

        function applyCloneCoupon(cart) {
            var code = cart && cart.couponCode;
            if (!code) {
                return;
            }
            DiscountCouponService.findByCode(code).then(
                function (result) {
                    var match = result && result.data ? result.data : null;
                    if (match) {
                        vm.selectedCoupon = match;
                        vm.invoice.discountCoupon = match.code;
                        vm.cloneCouponInitialValue = match.name || match.code;
                    } else {
                        vm.invoice.discountCoupon = code;
                        vm.cloneCouponInitialValue = code;
                    }
                    vm.calculatePrice();
                },
                function () {
                    vm.invoice.discountCoupon = code;
                    vm.cloneCouponInitialValue = code;
                    vm.calculatePrice();
                }
            );
        }

        function mapCloneCustomer(data) {
            var ci = data.customerInfo || {};
            var sa = (vm.invoice.shippingOption === "RECEIVE_AT_HOME")
                ? ((data.shippingInfo && data.shippingInfo.address) || ci)
                : null;
            return {
                id: $stateParams.cloneCustomerId || null,
                fullName: ci.fullName || null,
                email: ci.email || null,
                phone: ci.phone || null,
                customerIdentity: $stateParams.cloneCustomerIdentity || null,
                zipcode: sa ? (sa.zipCode || null) : null,
                address: sa ? (sa.address || null) : null,
                addressNumber: sa ? (sa.addressNumber || null) : null,
                complement: sa ? (sa.complement || null) : null,
                district: sa ? (sa.district || null) : null,
                city: sa ? (sa.city || null) : null,
                state: sa ? (sa.state || null) : null
            };
        }

        function rebuildCloneItems(list) {
            var flyerIds = list.map(function (item) {
                return item.flyerId;
            });
            FlyersService.findFlyersByIds(flyerIds).then(function (response) {
                var flyers = (response && response.data) || [];
                var missing = 0;
                list.forEach(function (item) {
                    var flyer = _.find(flyers, function (candidate) {
                        return candidate.id === item.flyerId;
                    });
                    if (!flyer) {
                        missing++;
                        return;
                    }
                    var size = item.detail && item.detail.size;
                    var colorName = item.detail && item.detail.color && item.detail.color.name;
                    var line = { flyer: flyer, quantity: item.quantity || 1, detail: null, color: undefined };
                    if (flyer.details && flyer.details.length) {
                        flyer.colors = getAllColors(flyer.details);
                        line.detail = pickCloneDetail(flyer, size, colorName);
                        if (line.detail && line.detail.color) {
                            line.color = line.detail.color;
                        }
                    }
                    vm.invoice.items.push(line);
                    prepareLineSelectModels(line);
                });
                vm.calculatePrice();
                if (missing > 0) {
                    toastr.warning($translate.instant("invoice.new.messages.some-clone-products-not-found"));
                }
            });
        }

        function pickCloneDetail(flyer, size, colorName) {
            var details = flyer.details || [];
            var match = details.filter(function (detail) {
                var sizeOk = !size || detail.size === size;
                var colorOk = !colorName || (detail.color && detail.color.name === colorName);
                return sizeOk && colorOk;
            });
            if (match.length) {
                return match[0];
            }
            match = details.filter(function (detail) {
                return !size || detail.size === size;
            });
            return match.length ? match[0] : details[0];
        }

        function querySearchCustomers(query) {
            if (!query || query.length < 2) {
                var defer = $q.defer();
                defer.resolve([]);
                return defer.promise;
            }
            return CustomerService.getByName(query, StoreInfoFactory.getStoreId()).then(function(result) {
                var data = result.data;
                if (!data) {
                    return [];
                }
                if (Array.isArray(data)) {
                    return data;
                }
                if (Array.isArray(data.content)) {
                    return data.content;
                }
                return [];
            }, function() {
                return [];
            });
        }

        function selectedCustomerChange(customer) {
            if (customer) {
                vm.invoice.customer = customer;
            } else {
                vm.invoice.customer = { fullName: vm.searchTextCustomer };
            }
            regeneratePaymentLinkMessageIfPristine();
        }

        $scope.$watch(function() { return vm.searchTextCustomer; }, function(val) {
            if (!vm.selectedCustomerModel) {
                vm.invoice.customer = vm.invoice.customer || {};
                vm.invoice.customer.fullName = val || '';
            }
        });

        vm.getTreatedName = function (item) {
            return InvoiceUtilsService.getTreatedName(item);
        };

        function querySearchProducts(query) {
            if (!query || query.length < 2) {
                return $q.resolve([]);
            }
            return $http
                .get("flyer/api/flyer/search", {
                    params: vm.requestParams(query),
                })
                .then(function (res) {
                    var d = res.data;
                    if (!d) {
                        return [];
                    }
                    if (angular.isArray(d.content)) {
                        return d.content;
                    }
                    if (angular.isArray(d)) {
                        return d;
                    }
                    return [];
                })
                .catch(function () {
                    return [];
                });
        }

        function onProductSelectedFromSearch(item) {
            if (!item) {
                return;
            }
            vm.selectedProduct({ originalObject: item });
        }

        function clearProductSearchField() {
            $scope.$evalAsync(function () {
                vm.searchTextProduct = "";
                vm.selectedProductItem = null;
            });
        }

        function filterProductMobile() {
            var q = (vm.productMobileSearch || "").trim();
            if (q.length < 2) {
                vm.productMobileResults = [];
                return;
            }
            querySearchProducts(q).then(function (results) {
                vm.productMobileResults = results || [];
            });
        }

        function toggleProductModal() {
            if (!vm.productModalVisible) {
                vm.productListItemClicked = false;
                vm.pendingProduct = null;
                vm.productMobileSearch = "";
            }
            vm.productModalVisible = !vm.productModalVisible;
            if (vm.productModalVisible) {
                filterProductMobile();
            }
        }

        function onProductMobileRowClick(flyer) {
            vm.productListItemClicked = true;
            vm.pendingProduct = flyer;
        }

        function isProductRowSelected(item) {
            if (!vm.productListItemClicked || !vm.pendingProduct || !item) {
                return false;
            }
            return item.id === vm.pendingProduct.id;
        }

        function closeProductModal() {
            if (!vm.productModalVisible) {
                return;
            }
            vm.productModalVisible = false;
            vm.productMobileSearch = "";
            vm.productMobileResults = [];
            vm.pendingProduct = null;
            vm.productListItemClicked = false;
        }

        function confirmProductSelection() {
            if (vm.productListItemClicked && vm.pendingProduct) {
                if (vm.selectedProduct({ originalObject: vm.pendingProduct })) {
                    closeProductModal();
                }
            } else {
                closeProductModal();
            }
        }

        function showLineItemColorSelector(item) {
            return (
                item.flyer &&
                item.flyer.details &&
                item.flyer.details.length &&
                item.flyer.colors &&
                item.flyer.colors.length >= 1 &&
                !vm.isImmoContext &&
                !(
                    item.flyer.details.length === 1 &&
                    item.flyer.details[0].color === null &&
                    item.flyer.details[0].size
                )
            );
        }

        function isLineItemVariationSelectDisabled(item) {
            if (!item || !item.flyer) {
                return true;
            }
            if (!item.flyer.details || !item.flyer.details.length) {
                return true;
            }
            var sizes = vm.filterSizes(item.color, item.flyer.details);
            if (!sizes || !sizes.length) {
                return true;
            }
            return (
                item.flyer.details &&
                item.flyer.details.length &&
                item.flyer.colors &&
                item.flyer.colors.length >= 1 &&
                item.color === undefined &&
                !vm.isImmoContext &&
                !(
                    item.flyer.details.length === 1 &&
                    item.flyer.details[0].color === null &&
                    item.flyer.details[0].size
                )
            );
        }

        vm.selectedProduct = function (item) {
            if (InvoiceUtilsService.hasPositiveFixedValue(vm.fixedValue)) {
                toastr.warning(
                    $translate.instant("invoice.new.messages.fixed-value-blocks-product")
                );
                clearProductSearchField();
                return false;
            }
            if (!item.originalObject.details) {
                for (var i = 0; i < vm.invoice.items.length; i++) {
                    var object = vm.invoice.items[i];
                    if (item.originalObject.id === object.flyer.id) {
                        toastr.warning(
                            $translate.instant(
                                "invoice.new.messages.product-already-exists"
                            )
                        );
                        clearProductSearchField();
                        return false;
                    }
                }
            } else if (
                !item.originalObject.details &&
                item.originalObject.inventory === 0
            ) {
                toastr.warning(
                    $translate.instant(
                        "invoice.new.messages.product-without-inventory"
                    )
                );
                clearProductSearchField();
                return false;
            }

            if (item.originalObject.details) {
                item.originalObject.colors = getAllColors(
                    item.originalObject.details
                );

                // Verifica se o produto tem apenas um detalhe sem cor, mas com tamanho
                if (
                    item.originalObject.details.length === 1 &&
                    item.originalObject.details[0].color === null &&
                    item.originalObject.details[0].size
                ) {
                    // Define automaticamente o detalhe
                    var newItem = {
                        flyer: item.originalObject,
                        quantity: 1,
                        detail: item.originalObject.details[0],
                    };
                    vm.invoice.items.push(newItem);
                    prepareLineSelectModels(newItem);
                } else {
                    var lineWithChoices = {
                        flyer: item.originalObject,
                        quantity: 1,
                        detail: null,
                    };
                    vm.invoice.items.push(lineWithChoices);
                    prepareLineSelectModels(lineWithChoices);
                }
            } else {
                var simpleLine = {
                    flyer: item.originalObject,
                    quantity: 1,
                    detail: null,
                };
                vm.invoice.items.push(simpleLine);
                prepareLineSelectModels(simpleLine);
            }
            vm.calculatePrice();
            clearProductSearchField();
            return true;
        };

        vm.onFixedValueInput = function () {
            var hasItems = vm.invoice.items && vm.invoice.items.length;
            var action = InvoiceUtilsService.resolveFixedValueInputAction(hasItems, vm.fixedValue);

            if (action === 'RESET_WITH_WARNING') {
                toastr.warning(
                    $translate.instant("invoice.new.messages.fixed-value-not-allowed-with-products")
                );
            }

            if (action === 'RESET_WITH_WARNING' || action === 'RESET') {
                $scope.$applyAsync(function () {
                    vm.fixedValue = null;
                    vm.calculatePrice();
                });
                return;
            }

            vm.calculatePrice();
        };

        vm.paymentConditionOptions = InvoiceUtilsService.getPaymentConditionOptions("invoice.new");

        vm.isPaymentConditionSelected = function (value) {
            return InvoiceUtilsService.isPaymentConditionSelected(
                vm.invoice.availablePaymentConditions,
                value
            );
        };

        vm.togglePaymentCondition = function (value) {
            InvoiceUtilsService.togglePaymentCondition(
                vm.invoice.availablePaymentConditions,
                value
            );
        };

        vm.getImage = function (item) {
            var imgId = item.flyer.id;
            if (item.color) {
                imgId =
                    parseInt(item.color.imgFlyerId) === 1
                        ? item.flyer.id
                        : item.flyer.id +
                        "__" +
                        String(parseInt(item.color.imgFlyerId) - 1);
            }
            return "flyer/api/" + imgId + "/picture?type=normal";
        };

        function getAllColors(variations) {
            var colors = [];
            var hasNoColor = false;

            // Verifica se existe algum item sem cor (API pode omitir o campo = undefined)
            hasNoColor = variations.some(function (variation) {
                return variation.color == null;
            });

            // Coleta todas as cores únicas
            variations.forEach(function (variation) {
                if (variation.color) {
                    var hasColor = colors.some(function (color) {
                        return color.id === variation.color.id;
                    });

                    if (!hasColor) {
                        var color = variation.color;
                        color.imgFlyerId = variation.imgsFlyerId
                            ? variation.imgsFlyerId.split(",")[0]
                            : undefined;
                        colors.push(color);
                    }
                }
            });

            // Adiciona a opção "Sem cor" apenas uma vez, se necessário
            if (hasNoColor) {
                colors.unshift({
                    id: null,
                    name: "Sem cor",
                    hex: "#BBBBBB",
                });
            }
            return colors;
        }

        vm.closeDropDown = function (event, level) {
            $("md-backdrop").trigger("click");
        };

        vm.selectedDiscountCoupon = function (item) {
            if (item && item.originalObject && item.originalObject.code) {
                if (!isDiscountCouponValid(item.originalObject)) {
                    toastr.warning(
                        $translate.instant(
                            "invoice.new.messages.invalid-discount-coupon"
                        )
                    );
                    return;
                }
                vm.invoice.discountCoupon = item.originalObject.code;
                vm.selectedCoupon = item.originalObject;
            } else {
                vm.invoice.discountCoupon = undefined;
                vm.selectedCoupon = undefined;
            }
            vm.calculatePrice();
        };

        function isDiscountCouponValid(item) {
            return (
                item &&
                (!item.hasUsageLimit ||
                    !item.couponAvailable ||
                    item.couponsAvailable > 0)
            );
        }

        vm.deleteProduct = function (index) {
            vm.invoice.items.splice(index, 1);
            vm.calculatePrice();
        };

        vm.duplicateProduct = function (product) {
            if (!product.details || product.details.length === 0) {
                toastr.warning(
                    $translate.instant(
                        "invoice.new.messages.product-cant-be-duplicated"
                    )
                );
                return;
            }

            var dupLine = {
                flyer: product,
                quantity: 1,
                detail: null,
            };
            vm.invoice.items.push(dupLine);
            prepareLineSelectModels(dupLine);
        };

        vm.requestParams = function (query) {
            return {
                page: 0,
                size: 10,
                storeId: StoreInfoFactory.getStoreId(),
                search: query,
            };
        };

        vm.requestDiscountCouponParams = function (query) {
            return {
                page: 0,
                size: 10,
                name: query,
                code: query,
                enabled: true,
            };
        };

        vm.selectedCustomer = function (item) {
            if (item && item.originalObject) {
                vm.invoice.customer = item.originalObject;
            }
        };

        vm.filterSizes = function (color, details) {
            if (!details) {
                return [];
            }

            if (vm.isImmoContext) {
                // Para contexto imobiliário, retorna todos os detalhes que têm unit
                return details.filter(function (detail) {
                    return detail.unit != null;
                });
            } else {
                // Para outros contextos
                return details.filter(function (detail) {
                    // Se nenhuma cor estiver selecionada, retorna todos os itens
                    if (color === undefined) {
                        return (
                            detail.inventory == null || detail.inventory >= 0
                        );
                    }

                    if (color === null || (color && color.id == null)) {
                        return (
                            detail.color == null &&
                            (detail.inventory == null || detail.inventory >= 0)
                        );
                    }
                    if (!color) {
                        return false;
                    }
                    return (
                        detail.color != null &&
                        detail.color.id == color.id
                    );
                });
            }
        };

        function variationOptionsIdentitySignature(detailsArray) {
            if (!detailsArray || !detailsArray.length) {
                return 'e';
            }
            return detailsArray
                .map(function (d) {
                    var cid = '';
                    if (d.color != null && Object.prototype.hasOwnProperty.call(d.color, 'id')) {
                        cid = d.color.id === null ? 'null' : String(d.color.id);
                    }
                    return (
                        (d.size || '') +
                        '\u001f' +
                        (d.unit || '') +
                        '\u001f' +
                        cid
                    );
                })
                .join('\u001e');
        }

        vm.getVariationSelectOptionsForLine = function (item) {
            if (!item || !item.flyer || !item.flyer.details) {
                return [];
            }
            var filtered = vm.filterSizes(item.color, item.flyer.details);
            var sig = variationOptionsIdentitySignature(filtered);
            if (item.__variationOptionsSig !== sig) {
                item.__variationOptionsSig = sig;
                item.__variationSelectOptions = filtered;
            }
            return item.__variationSelectOptions || [];
        };

        function sameInvoiceColor(candidate, reference) {
            if (candidate === reference || (candidate == null && reference == null)) {
                return true;
            }
            if (!candidate || !reference) {
                return false;
            }
            if (
                Object.prototype.hasOwnProperty.call(candidate, 'id') &&
                Object.prototype.hasOwnProperty.call(reference, 'id')
            ) {
                return candidate.id == reference.id;
            }
            return angular.equals(candidate, reference);
        }

        function sameInvoiceDetail(candidate, reference) {
            if (candidate === reference) {
                return true;
            }
            if (!candidate || !reference) {
                return false;
            }
            if (vm.isImmoContext) {
                return candidate.unit === reference.unit;
            }
            var sameSize = candidate.size === reference.size;
            var sameColorPair =
                !candidate.color && !reference.color
                    ? true
                    : candidate.color && reference.color
                        ? candidate.color.id === reference.color.id
                        : candidate.color == reference.color;
            return sameSize && sameColorPair;
        }

        function prepareLineSelectModels(lineItem) {
            if (!lineItem || !lineItem.flyer) {
                return;
            }

            vm.getVariationSelectOptionsForLine(lineItem);

            if (lineItem.flyer.colors && lineItem.color != null) {
                var palette = lineItem.flyer.colors;
                var cc = lineItem.color;
                for (var ci = 0; ci < palette.length; ci++) {
                    if (palette[ci] === cc) {
                        break;
                    }
                    if (sameInvoiceColor(palette[ci], cc)) {
                        lineItem.color = palette[ci];
                        break;
                    }
                }
            }

            var vopts = lineItem.__variationSelectOptions;
            if (!lineItem.detail || !vopts || !vopts.length) {
                return;
            }
            var dd = lineItem.detail;
            for (var di = 0; di < vopts.length; di++) {
                if (vopts[di] === dd) {
                    return;
                }
                if (sameInvoiceDetail(vopts[di], dd)) {
                    lineItem.detail = vopts[di];
                    return;
                }
            }
        }

        vm.changeColor = function (item) {
            item.detail = null;
            item.__variationOptionsSig = undefined;
            $timeout(function () {
                prepareLineSelectModels(item);
                vm.calculatePrice();
            });
        };

        vm.onLineVariationSelectChange = function (item, index) {
            item.quantity = 1;
            $timeout(function () {
                vm.calculatePrice();
                vm.checkIfVariationAlreadyExists(item, index);
            });
        };

        vm.changeCustomer = function (value) {
            if (vm.invoice.customer && vm.invoice.customer.id) {
                vm.invoice.customer = {
                    fullName: value,
                };
            } else if (!vm.invoice.customer.id) {
                vm.invoice.customer.fullName = value;
            }
        };

        vm.updatePurchaseValue = function () {
            vm.purchaseValue =
                vm.invoice.subTotal +
                vm.invoice.shippingValue -
                (vm.invoice.discount ? vm.invoice.discount : 0);
            if (
                !vm.invoice.subTotal ||
                vm.invoice.subTotal < 0 ||
                !vm.purchaseValue ||
                vm.purchaseValue < 0
            ) {
                vm.purchaseValue = 0;
            }
        };

        vm.calculatePrice = function () {
            var hasItems = !!(vm.invoice.items && vm.invoice.items.length);
            if (hasItems || vm.fixedValue) {
                InvoicesService.calculateDiscount(vm.invoice).then(
                    function (response) {
                        if (response.data) {
                            vm.invoice.discount = response.data;
                        } else {
                            vm.invoice.discount = undefined;
                        }
                        vm.updatePurchaseValue();
                    },
                    function (err) {
                        vm.invoice.discount = undefined;
                        vm.updatePurchaseValue();
                    }
                );
            }

            var subTotal = 0;
            if (hasItems) {
                angular.forEach(vm.invoice.items, function (item) {
                    if (item.flyer.details && item.flyer.details.length) {
                        if (item.detail) {
                            subTotal +=
                                item.quantity *
                                (item.detail.discountedValue
                                    ? item.detail.discountedValue
                                    : item.detail.purchaseValue);
                        }
                    } else {
                        subTotal +=
                            item.quantity *
                            (item.flyer.discountedValue
                                ? item.flyer.discountedValue
                                : item.flyer.purchaseValue);
                    }
                });
            } else if (vm.fixedValue) {
                subTotal = vm.fixedValue;
            }

            vm.invoice.subTotal = subTotal;
            if (!vm.invoice.shippingValue) {
                vm.invoice.shippingValue = 0;
            }
            vm.invoice.total = subTotal;
            vm.updatePurchaseValue();
        };

        vm.changeQuantity = function (item, value) {
            verifyQuantityMessage(item, item.quantity + value);
            if (item.quantity + value <= 0) {
                return;
            }

            if (
                item.flyer.inventory &&
                item.quantity + value <= item.flyer.inventory
            ) {
                item.quantity += value;
            }

            if (item.detail && item.detail.inventory) {
                if (item.quantity + value <= item.detail.inventory) {
                    item.quantity += value;
                }
            } else if (item.detail && item.detail.inventory == null) {
                item.quantity += value;
            }

            if (
                item.detail == null &&
                item.flyer.inventory == null &&
                item.flyer.details &&
                item.flyer.details.length == 0
            ) {
                item.quantity += value;
            }

            vm.calculatePrice();
        };

        vm.onChangeQuantity = function (item) {
            verifyQuantityMessage(item, item.quantity);
            if (item.quantity < 0) {
                item.quantity = 0;
            } else if (
                item.detail &&
                (item.quantity === undefined ||
                    item.quantity > item.detail.inventory)
            ) {
                item.quantity = item.detail.inventory;
            } else if (
                !item.detail &&
                item.flyer.inventory &&
                item.flyer.inventory !== 0 &&
                (item.quantity === undefined ||
                    item.quantity > item.flyer.inventory)
            ) {
                item.quantity = item.flyer.inventory;
            }

            vm.calculatePrice();
        };

        vm.save = function () {
            var saveErrorKey = InvoiceUtilsService.validateInvoiceForSave(vm.isImmoContext, vm.paymentLinkEnabled, vm.invoice, vm.fixedValue);
            if (saveErrorKey) {
                toastr.warning($translate.instant("invoice.new.messages." + saveErrorKey));
                return;
            }

            if (hasInvalidItem() || checkInvalidCustomer()) {
                return;
            }

            var request = InvoiceUtilsService.buildInvoiceRequest(vm.invoice, vm.isImmoContext, vm.selectedSalesPointId);
            if (!vm.isImmoContext) {
                request.paymentCondition = vm.paymentLinkEnabled
                    ? vm.invoice.availablePaymentConditions[0]
                    : vm.invoice.paymentCondition;
            }
            delete request.availablePaymentConditions;

            vm.isSaving = true;
            InvoicesService.createInvoice(request)
                .then(function () {
                    vm.isSaving = false;
                    toastr.success(
                        $translate.instant(
                            "invoice.new.messages.invoice-created"
                        )
                    );
                    $state.go("invoices");
                })
                .catch(function (err) {
                    vm.isSaving = false;
                    toastr.error(
                        $translate.instant(
                            "invoice.new.messages.error-to-created"
                        )
                    );
                });
        };

        vm.finalizeWithLink = function () {
            if (vm.isImmoContext) {
                return;
            }

            var linkErrorKey = InvoiceUtilsService.validatePaymentLinkInvoice(vm.invoice, {
                fixedValue: vm.fixedValue,
                isImmoContext: vm.isImmoContext,
                salesPoints: vm.salesPoints,
                selectedSalesPointId: vm.selectedSalesPointId
            });
            if (linkErrorKey) {
                toastr.warning($translate.instant("invoice.new.messages." + linkErrorKey));
                return;
            }

            submitPaymentLinkInvoice();
        };

        function submitPaymentLinkInvoice() {
            var request = InvoiceUtilsService.buildPaymentLinkRequest(vm.invoice, {
                isImmoContext: vm.isImmoContext,
                fixedValue: vm.fixedValue,
                standaloneProductName: vm.standaloneProductName,
                selectedSalesPointId: vm.selectedSalesPointId,
                paymentLinkMessage: vm.paymentLinkMessage
            });

            var paymentLinkUrl = {};
            var paymentLinkUrlPromise = new Promise(function (resolve, reject) {
                paymentLinkUrl.resolve = resolve;
                paymentLinkUrl.reject = reject;
            });
            var copyPromise = vm.isMobile ? null : copyToClipboardDeferred(paymentLinkUrlPromise);

            vm.isGeneratingLink = true;
            InvoicesService.createPaymentLinkInvoice(request)
                .then(function (response) {
                    vm.isGeneratingLink = false;
                    var uuid = response && response.data ? response.data.uuid : null;
                    if (!uuid) {
                        discardPendingCopy(paymentLinkUrl, copyPromise);
                        toastr.success(
                            $translate.instant("invoice.new.messages.payment-link-created")
                        );
                        $state.go("invoices");
                        return;
                    }
                    if (vm.isMobile) {
                        openPaymentLinkReadyModal(uuid);
                        return;
                    }
                    paymentLinkUrl.resolve(InvoiceUtilsService.buildPaymentLinkUrl(uuid));
                    handlePaymentLinkCopy(copyPromise, uuid);
                })
                .catch(function (error) {
                    vm.isGeneratingLink = false;
                    discardPendingCopy(paymentLinkUrl, copyPromise);
                    toastr.error(
                        $translate.instant("invoice.new.messages." + InvoiceUtilsService.resolvePaymentLinkCreateErrorKey(error))
                    );
                });
        }

        function discardPendingCopy(paymentLinkUrl, copyPromise) {
            if (copyPromise) {
                copyPromise.catch(angular.noop);
            }
            paymentLinkUrl.reject();
        }

        function handlePaymentLinkCopy(copyPromise, uuid) {
            copyPromise.then(function () {
                $scope.$applyAsync(function () {
                    toastr.success(
                        $translate.instant("invoice.new.messages.payment-link-created-and-copied")
                    );
                    $state.go("invoices");
                });
            }, function () {
                $scope.$applyAsync(function () {
                    toastr.warning(
                        $translate.instant("invoice.new.messages.payment-link-created-copy-manually")
                    );
                    openPaymentLinkReadyModal(uuid);
                });
            });
        }

        function openPaymentLinkReadyModal(uuid) {
            $uibModal.open({
                templateUrl: 'app/admin/invoices/payment-link-ready-modal/payment-link-ready-modal.html',
                controller: 'PaymentLinkReadyModalController',
                windowClass: 'alt-side-modal',
                windowTopClass: 'payment-link-ready',
                backdrop: 'static',
                controllerAs: 'vm',
                keyboard: false,
                resolve: {
                    paymentLinkData: function () {
                        return {
                            uuid: uuid,
                            paymentLinkMessage: vm.paymentLinkMessage,
                            customerPhone: (vm.invoice.customer && vm.invoice.customer.phone) || null
                        };
                    }
                }
            });
        }

        vm.checkCEP = function () {
            if (
                vm.invoice.shippingOption === "RECEIVE_AT_HOME" &&
                vm.invoice.customer.zipcode &&
                vm.invoice.customer.zipcode.length === 8
            ) {
                CheckCEPService.getAddress(vm.invoice.customer.zipcode).then(
                    function (response) {
                        if (response.data) {
                            vm.invoice.customer.address = response.data.name;
                            vm.invoice.customer.district =
                                response.data.district.name;
                            vm.invoice.customer.city =
                                response.data.location.name;
                            vm.invoice.customer.state =
                                response.data.location.uf;
                        }
                    }
                );
            } else {
                vm.invoice.customer.state = null;
            }
        };

        vm.checkIfVariationAlreadyExists = function (item, index) {
            for (var i = 0; i < vm.invoice.items.length; i++) {
                var object = vm.invoice.items[i];
                if (item.flyer.id === object.flyer.id) {
                    if (vm.isImmoContext) {
                        // Para contexto imobiliário, compara por unit
                        if (
                            item.detail &&
                            item.detail.unit === object.detail.unit &&
                            i !== index
                        ) {
                            toastr.warning(
                                $translate.instant(
                                    "invoice.new.messages.immo-unit-already-exists"
                                )
                            );
                            item.detail = undefined;
                            return;
                        }
                    } else {
                        // Para outros contextos, mantém a lógica original
                        if (
                            item.detail &&
                            item.detail.size === object.detail.size &&
                            item.detail.color &&
                            object.detail.color &&
                            item.detail.color.id === object.detail.color.id &&
                            i !== index
                        ) {
                            toastr.warning(
                                $translate.instant(
                                    "invoice.new.messages.product-variation-already-exists"
                                )
                            );
                            item.detail = undefined;
                            return;
                        }
                    }
                }
            }
        };

        function verifyQuantityMessage(item, value) {
            if (
                item.detail &&
                (value === undefined || (value > item.detail.inventory && item.detail.inventory !== null))
            ) {
                toastr.warning(
                    $translate.instant(
                        "invoice.new.messages.limit-amount-reached"
                    )
                );
            } else if (
                !item.detail &&
                item.flyer.inventory &&
                item.flyer.inventory !== 0 &&
                (value === undefined || value > item.flyer.inventory)
            ) {
                toastr.warning(
                    $translate.instant(
                        "invoice.new.messages.limit-amount-reached"
                    )
                );
            }
        }

        function hasInvalidItemDetails() {
            var itemErrorKey = InvoiceUtilsService.validateInvoiceItems(vm.invoice.items, vm.isImmoContext);
            if (itemErrorKey) {
                toastr.warning($translate.instant("invoice.new.messages." + itemErrorKey));
                return true;
            }
            return false;
        }

        function hasInvalidItem() {
            if (!vm.invoice.items || !vm.invoice.items.length) {
                toastr.warning(
                    $translate.instant("invoice.new.messages.select-a-product")
                );
                return true;
            }
            return hasInvalidItemDetails();
        }

        function hasInvalidCustomerBaseData() {
            var errorKey = InvoiceUtilsService.validateCustomerBaseData(vm.invoice.customer, vm.store && vm.store.hasErp);
            if (errorKey) {
                toastr.warning($translate.instant("invoice.new.messages." + errorKey));
                return true;
            }
            return false;
        }

        function hasInvalidShippingAddress() {
            if (InvoiceUtilsService.hasInvalidShippingAddress(vm.invoice)) {
                toastr.warning(
                    $translate.instant(
                        "invoice.new.messages.invalid-customer-address"
                    )
                );
                return true;
            }
            return false;
        }

        function checkInvalidCustomer() {
            return hasInvalidCustomerBaseData() || hasInvalidShippingAddress();
        }
    }
})();
